/* eslint-disable no-underscore-dangle */
import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import EntityGrid from "@gluenetworks/entity_grid_gl";
/* Helpers */
import {isUserWithDashboardViewerRole} from "../../../../../helpers/dashboard-helpers";
/* Styles */
import "./data-grid.scss";

export default class DataGrid extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this._entityGrid = EntityGrid.Grid;
        this._gridContainer = React.createRef();

        this._showDefaultMessage = _.debounce(this._showDefaultMessage.bind(this), 200);
        this._hideDefaultMessage = _.debounce(this._hideDefaultMessage.bind(this), 200);
    }

    componentDidMount() {
        if (!_.isEmpty(this.props.dataFeed)) {
            this.renderEntityGrid();
            if (this.props.dataFeed._totalEntities === 0) {
                this._showDefaultMessage();
            } else {
                this._hideDefaultMessage();
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (
            !_.isEmpty(this.props.dataFeed) &&
            !_.isEqual(prevProps.dataFeed, this.props.dataFeed)
        ) {
            this.renderEntityGrid();
            if (_.isEmpty(this.props.dataFeed.getFilterData())) {
                if (this.props.dataFeed._totalEntities === 0) {
                    this._showDefaultMessage();
                } else {
                    this._hideDefaultMessage();
                }
            }
        }
    }

    _showDefaultMessage() {
        this.entityGrid.renderer._emptyMessage.innerText = this.props.filter
            ? "No items match the specified filter criteria."
            : "No data available";
        if (
            !this.entityGrid.renderer._gridContainer.contains(
                this.entityGrid.renderer._emptyMessage
            )
        ) {
            this.entityGrid.renderer._gridContainer.appendChild(
                this.entityGrid.renderer._emptyMessage
            );
        }
    }

    _hideDefaultMessage() {
        if (
            this.entityGrid.renderer._gridContainer.contains(this.entityGrid.renderer._emptyMessage)
        ) {
            this.entityGrid.renderer._gridContainer.removeChild(
                this.entityGrid.renderer._emptyMessage
            );
        }
    }

    componentWillUnmount() {
        clearInterval(this.disableColumnDragInterval);
        if (this.entityGrid && typeof this.entityGrid.removeAllListeners === "function") {
            this.entityGrid.removeAllListeners("UserSorted", this.onUserSorted);
            this.entityGrid.removeAllListeners("UserRowDoubleClicked");
            this.entityGrid.removeAllListeners("UserSelectedRows");
        }
    }

    render() {
        return (
            <div className="glu-content grid-view">
                <div
                    ref={this._gridContainer}
                    className="grid-container grid-container__full-height"
                />
            </div>
        );
    }

    selectRows = (selection) => {
        const numberOfSelectedRows =
            selection && selection.selectedRows ? selection.selectedRows.length : 0;
        this.props.setSelectedAndTotalRows(
            numberOfSelectedRows,
            this.entityGrid.getTotalEntities()
        );
    };

    renderEntityGrid() {
        this.entityGrid = new this._entityGrid({
            gridKey: this.props.widgetId,
            columns: this.props.columnConfig,
            pagingFeed: this.props.dataFeed,
            showHeader: true,
        });
        this.entityGrid.addListener("UserSorted", this.onUserSorted);
        if (this._gridContainer.current.firstChild) {
            this._gridContainer.current.removeChild(this._gridContainer.current.firstChild);
        }
        this._gridContainer.current.appendChild(this.entityGrid.renderer.rootElement);
        if (!this.props.isEditAllowed && !isUserWithDashboardViewerRole()) {
            this.entityGrid.on("UserRowDoubleClicked", this.props.solutionRedirect);
        }
        this.entityGrid.on("UserSelectedRows", this.selectRows);

        // TODO
        /* This part of the code is hack made in order to set grid columns draggable attribute to false
         This should be changed so we can set draggable to false inside column config.
         */
        this.disableColumnDragInterval = setInterval(() => {
            const root = this.entityGrid.renderer.rootElement;
            if (root.getElementsByTagName("grid-column").length) {
                clearInterval(this.disableColumnDragInterval);
                const gridColumns = root.getElementsByTagName("grid-column");
                for (const col of gridColumns) {
                    col.setAttribute("draggable", false);
                }
            }
        }, 500);
        this.props.setSelectedAndTotalRows(
            this.entityGrid.getSelectedRows().length,
            this.entityGrid.getTotalEntities()
        );
    }

    onUserSorted = (sortData) => {
        sortData = [].concat(sortData);
        const sort = {};
        sortData.forEach((sortData) => {
            if (
                !sortData ||
                !sortData.sortColumn ||
                !this.props.columnConfig[sortData.sortColumn]
            ) {
                return;
            }
            const sortCriteria =
                this.props.columnConfig[sortData.sortColumn].valuePath ||
                this.props.columnConfig[sortData.sortColumn].path ||
                sortData.sortColumn;
            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });
        // this._patchSorting(sort);
        if (sort && !sort.name && this.props.columnConfig.name) {
            sort.name = 1;
        }
        this.props.dataFeed.setSort(sort);
        this.entityGrid.refreshView();
    };

    _patchSorting(sorting) {
        // add second sorting order by name
        if (sorting && !sorting.name && this.props.columnConfig.name) {
            sorting.name = 1;
        }
    }
}

DataGrid.propTypes = {
    columnConfig: PropTypes.objectOf(PropTypes.any).isRequired,
    dataFeed: PropTypes.objectOf(PropTypes.any),
    widgetId: PropTypes.string.isRequired,
    solutionRedirect: PropTypes.func.isRequired,
    isEditAllowed: PropTypes.bool.isRequired,
    setSelectedAndTotalRows: PropTypes.func.isRequired,
};

DataGrid.defaultProps = {
    dataFeed: null,
};
